import { reactLocalStorage } from 'reactjs-localstorage';

import Const from './Constants';

class DB {

  static getActions = model => {
    const user = reactLocalStorage.getObject(Const.LoggedInUser);
    const users = `${Const.Opt}${user.user_id}${Const.Opt}`;
    const roles = `${Const.Opt}${user.role}${Const.Opt}`;
    const actions = reactLocalStorage.getObject(Const.Actions);
    if(actions && Array.isArray(actions)) {
      return actions.filter(action => 
        action.model === model
        && ( 
          (!action.users && !action.roles) 
          || (action.roles && action.roles.includes(roles)) 
          || (action.users && action.users.includes(users))
        )
      );
    }
    return [];
  }
}
export default DB;